__turbopack_context__.v({
  "image": "Image-module-scss-module__DrMf8G__image",
  "isLoaded": "Image-module-scss-module__DrMf8G__isLoaded",
  "withFadeInAnimation": "Image-module-scss-module__DrMf8G__withFadeInAnimation",
});
